import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { useRouter } from '@tanstack/react-router';

export function BackButton() {
  const { history } = useRouter();

  const goBack = () => history.go(-1);

  return(
    <Button 
      variant="ghost" 
      className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded-md transition-colors"
      onClick={goBack}
      aria-label="Go back to previous page"
    >
      <ChevronLeft className="h-5 w-5" />
      <span>Back</span>
    </Button>
  )
}